<div class="row align-items-center mb-1">
  <div class="{{labelClass}}">
    <span class="label">{{label}}</span>
  </div>
  <div class="{{class}}">
    <div class="form-control d-flex align-items-center fake-input">
      @if (prefix) {
        <span class="pr-2">{{prefix}}</span>
      }
      <span>{{value}}</span>
    </div>
  </div>
  <div class="{{class2}}">
    @if (value2) {
      <div class="form-control d-flex align-items-center fake-input">
        @if (prefix2) {
          <span class="pr-2">{{prefix2 }}</span>
        }
        <span>{{value2}}</span>
      </div>
    }
  </div>
</div>